import React from 'react';
import { KanbanCard, MenuOptions } from '~/components';
import { DotsVertical, LoadingSpinner } from '~/ui/assets/icons';
import { Button } from '~/ui/components';
import {
  KanbanColumn as StyledKanbanColumn,
  KanbanColumnHeader,
  KanbanColumnContent,
  LoadingWrapper,
  ColumnHeaderTitle,
} from './KanbanColumn.styles';

export interface OptionsMenuProps {
  key: string;
  label: string | React.ReactNode;
  onClick: () => void;
}

export interface KanbanColumnProps {
  title: string;
  items: any[];
  count?: number;
  bgColor?: string;
  textColor?: string;
  borderColor?: string;
  onItemClick?: (item: any) => void;
  onUpdateItem?: (item: any) => void;
  onLoadMoreClick?: () => void;
  loading?: boolean;
  showLoadMoreButton?: boolean;
  optionsMenu?: OptionsMenuProps[];
  disabled?: boolean;
}

export function KanbanColumn({
  title,
  items,
  count,
  bgColor = 'background.secondary',
  borderColor = 'background.tertiary',
  textColor = 'element.secondary',
  onItemClick,
  onUpdateItem,
  onLoadMoreClick,
  showLoadMoreButton,
  loading,
  optionsMenu,
  disabled,
}: KanbanColumnProps) {
  return (
    <StyledKanbanColumn bgColor={bgColor} borderColor={borderColor} disabled={loading || disabled}>
      <KanbanColumnHeader color={textColor}>
        <ColumnHeaderTitle>
          {title} {loading ? <LoadingSpinner /> : `(${count || items.length})`}
        </ColumnHeaderTitle>

        {optionsMenu && (
          <MenuOptions options={optionsMenu} placement="bottomRight" width={170}>
            <DotsVertical className="dots-icon" />
          </MenuOptions>
        )}
      </KanbanColumnHeader>

      {loading && !items.length ? (
        <LoadingWrapper>
          <LoadingSpinner />
          <span>Carregando...</span>
        </LoadingWrapper>
      ) : (
        <KanbanColumnContent>
          {items.map((item) => (
            <KanbanCard key={item?.id} item={item} onClick={onItemClick} onUpdateItem={onUpdateItem} />
          ))}

          {!!items.length && showLoadMoreButton && (
            <Button
              variant="text"
              size="sm"
              fullWidth
              className="load-more-button"
              customColor={textColor}
              onClick={onLoadMoreClick}
            >
              Carregar mais
            </Button>
          )}

          {!items.length && !loading && <div className="no-items">Nenhum item encontrado</div>}
        </KanbanColumnContent>
      )}
    </StyledKanbanColumn>
  );
}
